import React, { Component } from 'react';
import { Modal, Button, Table, Badge, Spinner, Form, InputGroup } from 'react-bootstrap';

class DrilldownModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
        };
    }

    render() {
        const { show, onHide, title, data, loading, columnLabel } = this.props;
        const { searchQuery } = this.state;

        // Filter data based on search
        const filteredData = data.filter(item => 
            (item.name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.mobile || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.branch_name || '').toLowerCase().includes(searchQuery.toLowerCase())
        );

        return (
            <Modal show={show} onHide={onHide} size="xl" centered className="af-drilldown-modal">
                <Modal.Header closeButton className="border-0 px-4 pt-4">
                    <Modal.Title className="font-weight-bold" style={{ color: '#0f172a' }}>
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4 pb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <InputGroup className="af-search-group shadow-none" style={{ maxWidth: '300px' }}>
                            <InputGroup.Prepend>
                                <InputGroup.Text className="bg-transparent border-right-0 text-muted">
                                    <i className="fas fa-search" />
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                placeholder="Search students..."
                                className="border-left-0 shadow-none border-secondary-light"
                                value={searchQuery}
                                onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                style={{ height: '38px', fontSize: '14px' }}
                            />
                        </InputGroup>
                        <div className="text-muted small font-weight-bold">
                            SHOWING {filteredData.length} RECORDS
                        </div>
                    </div>

                    <div className="table-responsive border rounded" style={{ maxHeight: '500px', overflow: 'auto' }}>
                        <Table hover className="mb-0 overflow-hidden">
                            <thead className="bg-light sticky-top" style={{ zIndex: 10 }}>
                                <tr style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#64748b' }}>
                                    <th className="border-0 py-3 pl-4">Full Name</th>
                                    <th className="border-0 py-3">Contact</th>
                                    <th className="border-0 py-3">Branch</th>
                                    <th className="border-0 py-3">{columnLabel || 'Status'}</th>
                                    <th className="border-0 py-3 text-right pr-4">Profile</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-5">
                                            <Spinner animation="border" variant="primary" size="sm" />
                                            <p className="mt-2 small text-muted">Synchronizing data...</p>
                                        </td>
                                    </tr>
                                ) : filteredData.length > 0 ? (
                                    filteredData.map((item, idx) => (
                                        <tr key={idx} className="af-table-row-hover" style={{ fontSize: '14px' }}>
                                            <td className="py-3 pl-4 font-weight-bold text-dark">{item.name || 'Anonymous Student'}</td>
                                            <td className="py-3 text-muted">{item.mobile || 'No Contact'}</td>
                                            <td className="py-3">
                                                <Badge variant="light" className="border px-2 py-1 font-weight-normal" style={{ color: '#64748b' }}>
                                                    {item.branch_name}
                                                </Badge>
                                            </td>
                                            <td className="py-3">
                                                <span className={`badge badge-pill px-3 py-1 ${item.statusColor || 'badge-light'}`} style={{ fontSize: '11px' }}>
                                                    {item.status || 'Active'}
                                                </span>
                                            </td>
                                            <td className="py-3 text-right pr-4">
                                                <Button variant="link" className="p-0 text-primary font-weight-bold text-decoration-none" style={{ fontSize: '13px' }}>
                                                    Quick View →
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-5 text-muted small">
                                            No matching records found for this period.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 px-4 pb-4">
                    <Button variant="secondary" onClick={onHide} className="af-cancel-btn">
                        Close
                    </Button>
                </Modal.Footer>

                <style>{`
                    .af-drilldown-modal .modal-content { border-radius: 16px; border: none; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); }
                    .af-table-row-hover:hover { background-color: #f8fafc; }
                    .sticky-top { background: #f8fafc; }
                    .border-secondary-light { border-color: #e2e8f0; }
                `}</style>
            </Modal>
        );
    }
}

export default DrilldownModal;
